import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { MatchsCcuStat } from '../matchs-ccu-stat.model';

@JsonObject('MatchsCcuResultsResponse')
export class MatchsCcuResultsResponse extends ApiResultsResponse<MatchsCcuStat> {

  @JsonProperty('results', [MatchsCcuStat])
  override results: MatchsCcuStat[] = [];
}
